import { Link } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../OpenTabsContext";
import useNotify from "../unit/useNotify";
const ApplicationLinkIdField = ({ ...props }) => {
  const id = props.id;
  const loannum = props.loannum;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { openGlobalTabs } = useContext(OpenTabsContext);
  const navigate = useNavigate();

  const handleClick = (id: any, loannum: any) => {
    if (loannum == null || loannum == undefined) {
      loannum = "";
    }
    if (openGlobalTabs.length >= 6) {
      if (openGlobalTabs.includes("app-" + id + "-" + loannum)) {
        navigate(`/applicationSummary/` + id + "?loannum=" + loannum);
      } else {
        errorNotify("Cannot open more than 6 tabs.");
        return false;
      }
    } else {
      navigate(`/applicationSummary/` + id + "?loannum=" + loannum);
    }
  };

  return (
    <Link
      component="span"
      onClick={() => handleClick(id, loannum)}
      className="numericText"
      underline="none"
      sx={{
        "&.MuiLink-root": { color: "#1976d2" },
        cursor: "pointer",
        textDecoration: "none",
        "&.RaLink-link": {
          color: "#1976d2",
        },
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {id}
    </Link>
  );
};

export default ApplicationLinkIdField;
